// src/propertyManagement/pages/VendorsPage.jsx
import React, { useState, useMemo } from 'react';
import { useNavigate, Link }                from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Typography,
  IconButton
} from '@mui/material';
import { DataGrid, GridToolbar }            from '@mui/x-data-grid';
import MoreVertIcon                         from '@mui/icons-material/MoreVert';
export const dummyVendors = [
    {
      id: 1,
      firstName: 'Arturo',
      lastName:  'Quevedo',
      category: 'Contractors - General',
      phone:   '(901) 262-8347',
      email:   'quevedoarturo129@gmail.com',
      insuranceProvider: 'State Farm',
      expires: '12/31/2025',
      website: 'www.armidsouth.com'
    },
    {
      id: 2,
      firstName: 'B&B Property',
      lastName:  'Preservation',
      category: 'Contractors - Trash',
      phone:   '(901) 643-7413',
      email:   'harderwork91@gmail.com',
      insuranceProvider: 'Allstate',
      expires: '03/15/2024',
      website: 'www.bbpropertytrash.com'
    },
    {
      id: 3,
      firstName: 'Bayron',
      lastName:  'Tercero',
      category: 'Uncategorized',
      phone:   '(901) 612-7412',
      email:   'bayrontercero450@gmail.com',
      insuranceProvider: '',
      expires: '',
      website: ''
    },
    {
      id: 4,
      firstName: 'Brian',
      lastName:  'HVAC',
      category: 'Contractors - HVAC',
      phone:   '(901) 247-9305',
      email:   '',
      insuranceProvider: '',
      expires: '',
      website: ''
    },
    {
      id: 5,
      firstName: 'Cristian',
      lastName:  'Mireles',
      category: 'Contractors - Roofing',
      phone:   '(901) 786-2919',
      email:   'roofing.onestop@yahoo.com',
      insuranceProvider: 'Farmers',
      expires: '08/10/2025',
      website: ''
    },
    {
      id: 6,
      firstName: 'Dana',
      lastName:  'Gragen',
      category: 'Contractors - General',
      phone:   '(901) 587-3913',
      email:   '',
      insuranceProvider: '',
      expires: '',
      website: ''
    },
    {
      id: 7,
      firstName: 'Daniel',
      lastName:  'Mojica',
      category: 'Contractors - Electrical',
      phone:   '(901) 634-5972',
      email:   'dmojicad33@gmail.com',
      insuranceProvider: 'Geico',
      expires: '11/01/2025',
      website: ''
    },
    {
      id: 8,
      firstName: 'Fortitude',
      lastName:  'Home Services',
      category: 'Contractors - General',
      phone:   '(901) 239-3970',
      email:   'bestcareservices@hotmail.com',
      insuranceProvider: '',
      expires: '',
      website: ''
    },
    {
      id: 9,
      firstName: 'Johnny',
      lastName:  'Maintenance',
      category: 'Contractors - Repair',
      phone:   '(901) 555-1234',
      email:   'johnnymaint@gmail.com',
      insuranceProvider: '',
      expires: '',
      website: ''
    },
    {
      id: 10,
      firstName: 'Oliver',
      lastName:  'Landscaping',
      category: 'Contractors - Lawn',
      phone:   '(901) 777-9876',
      email:   'oliverlawn@gmail.com',
      insuranceProvider: '',
      expires: '',
      website: ''
    }
  ];
export default function VendorsPage() {
  const navigate = useNavigate();

  // Filters & search state
  const [category, setCategory]           = useState('All categories');
  const [filterOption, setFilterOption]   = useState('');
  const [searchText, setSearchText]       = useState('');

  // Dummy vendor data
  

  // Column definitions
  const columns = [
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      renderCell: p => `${p.value} ${p.row.lastName}`,
    },
    {
      field: 'category',
      headerName: '',
      flex: 1.5,
      renderCell: p => <small style={{ color:'#777' }}>{p.value}</small>
    },
    {
      field: 'phone',
      headerName: 'Phone',
      flex: 1.2,
      renderCell: p => (
        <>
          <Typography component="span">{p.value}</Typography>
          <br/>
          <Link to="#" style={{ fontSize:12, color:'#007bff' }}>
            Send opt-in text message
          </Link>
        </>
      )
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1.5,
      renderCell: p => p.value
        ? <Link to={`mailto:${p.value}`} style={{ color:'#007bff' }}>
            {p.value}
          </Link>
        : '—'
    },
    {
      field: 'insuranceProvider',
      headerName: 'Insurance Provider',
      flex: 1.5
    },
    {
      field: 'expires',
      headerName: 'Expires',
      flex: 1
    },
    {
      field: 'website',
      headerName: 'Website',
      flex: 1,
      renderCell: p => p.value
        ? <a href={p.value.startsWith('http')?p.value:`https://${p.value}`} target="_blank" rel="noreferrer">
            {p.value}
          </a>
        : '—'
    },
    {
      field: 'actions',
      headerName: '',
      width: 48,
      sortable: false,
      renderCell: () => (
        <IconButton size="small">
          <MoreVertIcon fontSize="small" />
        </IconButton>
      )
    }
  ];

  // Global search filter
  const rows = useMemo(() => {
    if (!searchText) return dummyVendors;
    const lower = searchText.toLowerCase();
    return dummyVendors.filter(v =>
      Object.values(v).join(' ').toLowerCase().includes(lower)
    );
  }, [searchText]);

  return (
    <Box sx={{ p:3, display:'flex', flexDirection:'column', gap:3, height:'100%' }}>
      {/* Header */}
      <Typography variant="h5">Vendors</Typography>

      {/* Top actions */}
      <Box sx={{ display:'flex', justifyContent:'space-between', gap:2 }}>
        <Box sx={{ display:'flex', gap:1 }}>
          <Button
            variant="contained"
            onClick={() => navigate('/pm/maintenance/vendors/add')}
          >
            Add vendor
          </Button>
          <Button variant="outlined">Manage categories</Button>
          <Button variant="outlined">Compose email</Button>
        </Box>
        <TextField
          placeholder="Search vendors"
          variant="outlined"
          size="small"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />
      </Box>

      {/* Filters */}
      <Box sx={{ display:'flex', gap:2, alignItems:'center', mb:1 }}>
        <FormControl size="small" sx={{ minWidth:200 }}>
          <InputLabel>All categories</InputLabel>
          <Select
            value={category}
            label="All categories"
            onChange={e => setCategory(e.target.value)}
          >
            <MenuItem value="All categories">All categories</MenuItem>
            {[...new Set(dummyVendors.map(v=>v.category))]
              .map(cat => (
                <MenuItem key={cat} value={cat}>{cat}</MenuItem>
              ))
            }
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth:200 }}>
          <InputLabel>Add filter option</InputLabel>
          <Select
            value={filterOption}
            label="Add filter option"
            onChange={e => setFilterOption(e.target.value)}
          >
            <MenuItem value="">Add filter option</MenuItem>
            <MenuItem value="insuranceProvider">Insurance Provider</MenuItem>
            <MenuItem value="expires">Expires</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* DataGrid */}
      <Box sx={{ flexGrow:1 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10,25,50]}
          disableSelectionOnClick
          components={{ Toolbar: GridToolbar }}
          componentsProps={{ toolbar:{ showQuickFilter:false } }}
          onRowClick={params =>
            navigate(`/pm/maintenance/vendors/${params.id}`)
          }
        />
      </Box>
    </Box>
  );
}